<template>
  <ArticlesItem :article="article" @route="onRoute" />
</template>

<script>
import ArticlesItem from '@/components/ArticlesItem'
import api from '@/api'
import utils from '@/utils'

export default {
  name: 'ArticleView',

  components: {
    ArticlesItem
  },

  data () {
    return {
      article: {}
    }
  },

  props: {
    params: {
      type: Object,
      required: true
    }
  },

  created () {
    utils.tealiumTrack(this, {
      page_type: 'article view'
    })

    api.getArticle({ articleId: this.params.articleId, lang: this.$lang })
      .then((article) => {
        this.article = article
      })
  },

  watch: {
    params: function () {
      api.getArticle({ articleId: this.params.articleId, lang: this.$lang })
        .then((article) => {
          this.article = article
        })
    }
  },

  methods: {
    onRoute (route) {
      this.$emit('route', route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ArticleView.vue